export default "__VITE_ASSET__31da20d9__"